var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"end-text"},[_c('ul',[_c('li',[_vm._v("Copyright "+_vm._s(_vm.year)+" All Rights Reserved Powered by Chongwen Academy")]),_vm._v(" "),_c('li',[_vm._v("浙ICP备15006741号-3")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.address))]),_vm._v(" "),_c('li',[_vm._v("TEL."+_vm._s(_vm.tel))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530a8aed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 